import {
    Easing,
    SharedValue,
    useAnimatedReaction,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated'

export const useAnimatedDimensionStyle = (
    dimension: SharedValue<number>,
    expanded: SharedValue<boolean>,
    horizontal?: boolean
) => {
    const animatedDimension = useSharedValue(0)

    useAnimatedReaction(
        () => expanded.value,
        (currentValue, previousValue) => {
            if (previousValue === null || currentValue === previousValue) return

            const value = dimension.value * Number(expanded.value)

            animatedDimension.value = withTiming(value, {
                duration: 150,
                easing: Easing.out(Easing.linear),
            })
        }
    )

    useAnimatedReaction(
        () => dimension.value,
        (currentValue, previousValue) => {
            if (previousValue === null || Math.round(currentValue) === Math.round(previousValue))
                return

            animatedDimension.value = dimension.value * Number(expanded.value)
        }
    )

    const animatedWidthStyle = useAnimatedStyle(() => ({
        width: animatedDimension.value,
    }))
    const animatedHeightStyle = useAnimatedStyle(() => ({
        height: animatedDimension.value,
    }))

    return horizontal ? animatedWidthStyle : animatedHeightStyle
}
